import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle, Button, Loading, Stepper } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import ChooseUsers from './choose-users'
import { Fade } from '@material-ui/core'
import * as actions from './actions'
import ChooseEntities from './choose-entities'
import ConfirmShare from './confirm-share'
import SharingSuccess from './sharing-success'
import { UserPermissions } from '../../services/permissions'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    pageTitle: {
        justifyContent: 'space-between'
    },
    pageTitleButtons: {
        display: 'flex'
    },
    nextButton: {
        marginLeft: 8
    },
    stepDetailsWrapper: {
        marginBottom: 24,
        height: 'calc(100% - 240px)'
    }
}))

export default function Sharing(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, locale } = useSelector(state => state.main)

    const steps = [
        locale.sharing.chooseUsers,
        locale.sharing.chooseItems,
        locale.sharing.confirmAndShare
    ]
    const isLocationsGranted = UserPermissions.location().create
    const isDevicesGranted = UserPermissions.device().create
    const isReportsGranted = UserPermissions.report().create

    const {
        sharedUsers,
        selectedSharedUsers,
        selectedLocations,
        selectedDevices,
        selectedReports,
    } = useSelector(state => state.sharing)

    const [activeStep, setActiveStep] = useState(0)

    const onBackClick = (activeStep) => {
        let newActiveStep = activeStep
        if (activeStep > 0) newActiveStep -= 1
        setActiveStep(newActiveStep)
    }

    const onNextClick = (activeStep) => {
        let newActiveStep = activeStep
        if (activeStep < 2) newActiveStep += 1
        setActiveStep(newActiveStep)
    }

    const isBackVisible = (activeStep) => {
        return activeStep > 0 && activeStep < 3
    }

    const isNextVisible = (activeStep) => {
        let isVisible = false
        switch(activeStep) {
            case 0:
                if (selectedSharedUsers.length > 0) isVisible = true
                break
            case 1:
                if (selectedLocations.length > 0) isVisible = true
                if (selectedDevices.length > 0) isVisible = true
                if (selectedReports.length > 0) isVisible = true
                break
        }
        return isVisible
    }

    useEffect(() => {
        dispatch(actions.sharingEntitiesRequest({
            isLocationsGranted,
            isDevicesGranted,
            isReportsGranted
        }))
        return () => {
            dispatch(actions.sharedUsersSuccess([]))
            dispatch(actions.locationsRequestSuccess([]))
            dispatch(actions.devicesRequestSuccess([]))
            dispatch(actions.reportsRequestSuccess([]))
            dispatch(actions.setSelectedSharedUsers([]))
            dispatch(actions.setSelectedLocations([]))
            dispatch(actions.setSelectedDevices([]))
            dispatch(actions.setSelectedReports([]))
            dispatch(actions.shareError())
        }
    }, [])

    return (
        <div className={classes.wrapper}>
            <React.Fragment>
                <PageTitle
                    title={locale.sharing.sharing}
                    className={classes.pageTitle}
                >
                    <div className={classes.pageTitleButtons}>
                        <Fade in={isBackVisible(activeStep)} timeout={500}>
                            <Button
                                reverted
                                onClick={onBackClick.bind(this, activeStep)}
                            >
                                {locale.common.back}
                            </Button>
                        </Fade>
                        <Fade in={isNextVisible(activeStep)} timeout={500}>
                            <Button
                                className={classes.nextButton}
                                onClick={onNextClick.bind(this, activeStep)}
                            >
                                {locale.common.next}
                            </Button>
                        </Fade>
                    </div>
                </PageTitle>
                <div>
                    <Stepper
                        steps={steps}
                        activeStep={activeStep}
                    />
                </div>
                <div className={classes.stepDetailsWrapper}>
                    {isLoading &&
                        <Loading/>
                    }
                    {!isLoading &&
                        <React.Fragment>
                            {activeStep === 0 &&
                                <ChooseUsers
                                    sharedUsers={sharedUsers}
                                />
                            }
                            {activeStep === 1 &&
                                <ChooseEntities/>
                            }
                            {activeStep === 2 &&
                                <ConfirmShare
                                    setActiveStep={setActiveStep}
                                />
                            }
                            {activeStep === 3 &&
                                <SharingSuccess/>
                            }
                        </React.Fragment>
                    }
                </div>
            </React.Fragment>
        </div>
    )
}
